<template>
  <div
    :class="{'disabled-item': isLocked}"
    class="wrapper-card-nav wrapper-card-base h-100"
    :style="`--accent-nav: ${element.accentColor};`"
  >
    <router-link :to="element.path">
      <!-- <div :class="[(!managementAccess && item.title == 'setor') || (!alertsAccess && item.title == 'alertas') ? 'dashboard-card-bg-premium' :'dashboard-card-bg'  ,'dashboard-card']" > -->
      <div :class="['dashboard-card-bg'  ,'dashboard-card']" class="mb-0 pb-0 h-100 " >
        <a>
          <!-- class="dashboard-card col-xs-11 col-sm-5 " -->
          <div class="dashboard-item ">
            <div class="topCard align-items-center" lang="de">
              <div class="icons">
                <component :is="element.icon" title="" />
              </div>
              <div class="card-info ml-2 ml-lg-3">
                <div class="title">{{ element.title }}</div>
                <div v-if="element.description" class="card-description" style="hyphens: auto; ">{{ element.description }}</div>
              </div>
            </div>

            <!-- <hr /> -->
            <div class="card-details-container col-xs-12">
              <div class="card-details">

              </div>
            </div>

            <footer>
              <div v-if="isLocked">
                <router-link
                  :to="{ path: '/news'}"
                  class="btn"
                >
                  <lock-icon title="" />
                  <span> {{ element.lockedMessage }} </span>
                </router-link>
              </div>

              <div v-else>
                <router-link :to="element.path" class="btn" @click.native="element.redirectTo ? redirectTo(element.redirectTo): ''">
                  <arrow-right-icon title="" />
                  <span>Ir para {{ element.title }}</span>
                </router-link>
              </div>
            </footer>
          </div>
        </a>
      </div>
    </router-link>
  </div>
</template>

<script>
import { redirectTo } from "../../../common/constants/routes";
export default {
  methods: {
    redirectTo
  },
  props: {
    element: {
      type: Object,
      default: () => {}
    },
  },
  computed: {
    isLocked() {
      return !!(this.element.isLocked);
    },
  }
};
</script>

<style scoped>
.wrapper-card-nav,
.wrapper-card-nav:hover {

  transition: all 0.2s;
}
.wrapper-card-nav:hover {
  border: 1px solid #0000002b;
  filter: brightness(92%);
}

.dashboard-item .btn {
  transition: all 0.4s;
}
/* .dashboard-item .btn:hover {
  filter: brightness(92%);
} */
.dashboard-card-bg .icons {
  color: var(--accent-nav);
}

.title-info-card {
  font-weight: 600;
  padding: 0;
  margin: 0;
}
.dashboard-card-bg .title {
  font-weight: 600;
  font-size: 1.3em;
  color: var(--accent-nav);
}
.dashboard-card-bg-premium .icons {
  color: rgb(94, 94, 94);
}
.dashboard-card-bg-premium .title {
  font-weight: 600;
  font-size: 1.3em;
  color: var(--text-secondary-color-black);
}
.details-container {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
.details-container .btn {
  max-width: 110px;
  align-self: flex-end;
  border: 1px solid #e9723b;
  border-radius: 60px;
  padding: 2px 8px;
  font-size: 0.8em;
  color: #e9723b;
  text-align: center;
}
.details-container .btn:hover {
  background-color: #e27746;
  color: white;
}
.card-description {
  color: var(--text-gray-primary);
  font-size: 0.75em;
  padding-top: 5px;
}

@media screen and (max-width: 1100px) and (min-width: 767px) {
  .card-description {
    font-size: 0.8em;
  }
  hr {
    margin: 6px;
  }
  .title {
    font-size: 1.1em;
  }
}
@media screen and (max-width: 767px) {
  .title {
    font-size: 1.1em;
    margin-bottom: 4px;
  }
  .card-description {
    font-size: 0.75em;
  }
  .dashboard-card .dashboard-item .card-info {
    line-height: 0.8em;
  }
  .material-design-icon {
    font-size: 3em;
  }
  footer a .material-design-icon {
    font-size: 1.2em;
  }
  .card-details-container {
    font-size: 0.8em;
  }
}
</style>
